// extracted by mini-css-extract-plugin
export var pillWrapper = "_nt-0";
export var showOverflow = "_nt-1";